import type { ListBuilderList } from '../../../types';
import {
	accountColumn,
	actionColumn,
	fileVsRegulatorColumn,
	licenseColumn,
	salesColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters } from '../filter-rules';

/**
 * Ready to Confirm — active buyers with no verified license yet but a 90%+ suggestion waiting for a reviewer. Same client-level predicate as the dashboard's Unconfirmed Match card.
 */
export const readyToConfirmList: ListBuilderList = {
	id: 'compliance-ready-to-confirm',
	cacheTTL: 300000,
	// Tab label, deliberately short (Chris, 2026-09-20) so more tabs show in
	// the Needs Attention strip; the rest sit under More, which is accepted
	// (Chris, 2026-09-27). The full name is above and on the dashboard card.
	name: 'To Confirm',
	type: 'default',
	active: true,
	sortOrder: 10,
	filterRules: {
		...hideOtherCardFilters(['licenseClientCoverage']),
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseClientCoverage: {
			defaultValue: [{ id: 'unconfirmed', label: 'Ready to Confirm' }],
			locked: true,
		},
	},
	columns: [
		accountColumn,
		salesColumn,
		licenseColumn,
		fileVsRegulatorColumn,
		whyHereColumn,
		actionColumn,
	],
	defaultSortId: 'sales-90-desc',
};
